import ComparisonAccordion from './ComparisonAccordion';

export default ComparisonAccordion;
